export const carouselData = [
  {
    src: 'https://www.theciderfarm.com/wp-content/uploads/2020/11/Brandy-5-and-Maple-Syrup-Small.png',
    alt: '',
    title: '',
  },
  {
    src: 'https://www.theciderfarm.com/wp-content/uploads/2023/10/Brandy-Maple-Box-scaled.jpg',
    alt: '',
    title: '',
  },
  {
    src: 'https://www.theciderfarm.com/wp-content/uploads/2023/10/Gift-Boxes.jpg',
    alt: '',
    title: '',
  },
  {
    src: 'https://www.theciderfarm.com/wp-content/uploads/2023/10/Sunday-Jazz-Board.jpg',
    alt: '',
    title: '',
  },
];
